import React from "react";
import Header from './Header';
import Search from './Search';
import HistoryModal from './HistoryModal';
import ComparisonModal from './ComparisonModal';
import Recommendation from './Recommendation';
import InfoModal from './InfoModal';

// import AuthStatus from './AuthStatus';

const Content = (props) => {
  return (
    <div>
      {props.showInfo && <InfoModal showModal={props.showModal} />}

      {props.showRec ? <div>
        {props.showHistory && <HistoryModal showModal={props.showModal} songHistory={props.songHistory} changeActiveSong={props.changeActiveSong} recommendedSongId={props.recommendedSongId} />}
        {props.showComparison && <ComparisonModal showModal={props.showModal} parameters={props.parameters} userSong={props.userSong} recommendedSong={props.recommendedSong} />}
        

        <Recommendation
          userInfo={props.userInfo}
          userSong={props.userSong}
          recommendedSong={props.recommendedSong}
          selectedGenre={props.selectedGenre}
          handleReset={props.handleReset}
          recommendedSongPaused={props.recommendedSongPaused}
          userSongPaused={props.userSongPaused}
          playAudio={props.playAudio}
          tryAnother={props.tryAnother}
          showModal={props.showModal}
          saveSong={props.saveSong}
          recommendedSongId={props.recommendedSongId}
          checkLibrary={props.checkLibrary}
          handlePlaybackEnd={props.handlePlaybackEnd}
        />

      </div> : <div>

          <Header
            currentTitle={props.currentTitle}
            updateHeader={props.updateHeader}
          />
          <Search
            searchTerm={props.searchTerm}
            updateSearch={props.updateSearch}
            genres={props.genres}
            selectedGenre={props.selectedGenre}
            key={props.genres.code}
            updateGenre={props.updateGenre}
            handleToggleClick={props.handleToggleClick}
            showGenres={props.showGenres}
            songAutofill={props.songAutofill}
            showAutofill={props.showAutofill}
            autofillSongs={props.autofillSongs}
            userSongId={props.userSongId}
            handleRecommendation={props.handleRecommendation}
            handleParamChange={props.handleParamChange}
            parameters={props.parameters}
            showParams={props.showParams}
            showModal={props.showModal}
            randomizeSelection={props.randomizeSelection}
          />
        </div>}
    </div>
  )
}


export default Content;